exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#modal{position:fixed;z-index:10;top:0;left:0;right:0;bottom:0;background-color:rgba(53,53,53,0.8);overflow-y:auto;overflow-x:hidden}\n", ""]);
